import { action } from 'easy-peasy';

import { IActionResetMessages } from '../types';

const resetMessages: IActionResetMessages = action(state => {
  state.messages = {};
});

export default resetMessages;
